module.exports = __webpack_public_path__ + "img/2.6cb018c7.jpg";